<template>
  <div>
    <countdown v-if="currentStage === 'countdown'" @startGame="startGame" />
    <puzzle
      v-if="currentStage === 'puzzle'"
      :number="puzzleNumber"
      :name="`/spot/${puzzleNumber}-min.jpg`"
      :options="options[puzzleNumber - 1]"
      :description="questions[puzzleNumber - 1]"
      :keyboard="false"
      :countdown="false"
      :largeButtons="true"
      @complete="puzzleComplete"
    />
    <pause
      v-if="currentStage === 'pause'"
      :solution="solution[puzzleNumber - 1]"
      :legCorrect="lastLegCorrect"
      @nextPuzzle="nextPuzzle"
    />
    <game-over
      v-if="currentStage === 'gameover'"
      :user="''"
      :time="userTime"
      :score="userScore"
    />
  </div>
</template>

<script>
import Countdown from '@/components/Countdown'
import Puzzle from '@/components/PuzzleSmall'
import Pause from '@/components/Pause'
import GameOver from '@/components/GameOver'

export default {
  components: {
    Countdown,
    Puzzle,
    Pause,
    GameOver,
  },

  data: function() {
    return {
      puzzleNumber: 1,
      currentStage: 'countdown',
      choices: [],
      times: [],
      userScore: '',
      userScoreNumber: 0,
      userTime: 0,
      solution: [
        '3',
        'Path',
        'Pit',
        'Wall',
        'Ruin',
        '5',
        'Contour',
        '3',
        'Semi Open',
        'Stony Ground',
      ],
      options: [
        ['1', '2', '3', '4'],
        ['Building', 'Boulder', 'Path', 'Fence'],
        ['Pit', 'Building', 'Fence', 'Contour'],
        ['Fence', 'Wall', 'Open Area', 'Vegetation Boundary'],
        ['Boulder', 'Fence', 'Forest', 'Ruin'],
        ['3', '4', '5', '6'],
        ['Nothing', 'Green', 'Boulder', 'Contour'],
        ['2', '3', '4', '5'],
        ['Contour', 'Cliff', 'Semi Open', 'Green'],
        ['Nothing', 'Green', 'Stony Ground', 'Contour'],
      ],
      questions: [
        'How many buildings are missing?',
        'What is new?',
        'What is missing?',
        'What is new?',
        'What has changed?',
        'How many green areas have gone?',
        'What’s missing?',
        'How many boulders are missing?',
        'What has changed?',
        'What has changed?',
      ],
    }
  },

  computed: {
    lastLegCorrect: function() {
      return (
        this.solution[this.puzzleNumber - 1] ===
        this.choices[this.puzzleNumber - 1]
      )
    },
  },

  methods: {
    startGame: function() {
      this.currentStage = 'puzzle'

      if (this.puzzleNumber >= this.solution.length) {
        this.currentStage = 'gameover'

        this.userScore = this.scoreUser()
        this.userTime = this.times.reduce((a, b) => a + b, 0)
      }
    },

    puzzleComplete: function(result) {
      this.choices.push(result.choice)
      this.times.push(result.time)

      this.currentStage = 'pause'
    },

    nextPuzzle: function() {
      if (this.puzzleNumber >= this.solution.length) {
        this.currentStage = 'gameover'

        this.userScore = this.scoreUser()
        this.userTime = this.times.reduce((a, b) => a + b, 0)
      } else {
        this.puzzleNumber += 1
        this.currentStage = 'puzzle'
      }
    },

    scoreUser: function() {
      let correct = 0
      let i = 0

      while (i < this.choices.length) {
        if (this.solution[i] === this.choices[i]) correct += 1
        i += 1
      }

      this.userScoreNumber = correct
      return `${correct}`
    },
  },
}
</script>
